module.exports = __webpack_public_path__ + "static/media/img120_R.41e0000d.jpg";